import {Component, Input} from '@angular/core';
import {TableColumn} from '../ace-table.component';

@Component({
  selector: 'app-ace-table-default-cell',
  templateUrl: './ace-table-default-cell.component.html',
  styleUrls: ['./ace-table-default-cell.component.scss'],
  standalone: false
})
export class AceTableDefaultCellComponent {
  @Input() column: TableColumn;
  @Input() value: string | number;
}
